import ULink from './index.vue';

export {
    ULink,
};

export default ULink;
